import EmployeeContactDetails from '../components/EmployeeContactDetails'

export default EmployeeContactDetails;